export default __webpack_public_path__ + "static/jessica-sunardi-994ccdbd2380ce1a1f13f3fc46db47b8.webp";